import React, { useState } from "react";
import { Modal, Form, Col } from "react-bootstrap";
import toast from "react-hot-toast";
import ReactLoading from "react-loading";
import { refreshPage, toastStyle } from "../../../../Helpers/Utils/Common";
import { addPurchaseRequestNote } from "../../../../Helpers/apiCalls/Purchases/purchaseRequestApi";

export default function AddNoteModal(props) {
    const [details, setDetails] = useState("");
    const [isConfirmClicked, setIsConfirmClicked] = useState(false);

    async function handleAddNote() {
        setIsConfirmClicked(true);

        const response = await addPurchaseRequestNote(props.id, details);
        if (response.data) {
            toast.success("Successfully added note!", {
                style: toastStyle(),
            })

            setTimeout(() => {
                refreshPage();
                setDetails("");
            }, 1000);
        } else {
            toast.error("Something went wrong", {
                style: toastStyle(),
            });
            setTimeout(() => {
                setDetails("");
                refreshPage();
                setIsConfirmClicked(false);
            }, 1000);
        }
    }

    return (
        <div>
            <Modal show={props.show} onHide={props.hide} size="lg" centered>
                <Modal.Header className="return-header">
                    <span
                        className={
                            props.type === "disapprove"
                                ? "color-red"
                                : ""
                        }
                    >
                        ADD NOTE
                    </span>
                </Modal.Header>
                <Modal.Body className="return-body text-center">
                    <Col className="text-left pt-3">
                        <span>DETAILS</span>
                        <Form.Control
                            as="textarea"
                            name="details"
                            defaultValue={details}
                            className="nc-modal-custom-row-grey"
                            onChange={(e) => setDetails(e.target.value)}
                        />
                    </Col>
                </Modal.Body>
                <Modal.Footer className="return-footer">
                    <button
                        type="button"
                        className={
                            props.type === "disapprove"
                                ? "button-warning"
                                : "button-secondary"
                        }
                        onClick={props.hide}
                    >
                        Close
                    </button>
                    {isConfirmClicked ? (
                        <div
                            className={
                                props.type === "disapprove"
                                    ? "button-warning-fill d-flex justify-content-center"
                                    : "button-primary d-flex justify-content-center"
                            }
                        >
                            <ReactLoading
                                type="bubbles"
                                color={
                                    props.type === "disapprove"
                                        ? "#FFFFFF"
                                        : "#FFFFFF"
                                }
                                height={50}
                                width={50}
                            />
                        </div>
                    ) : (
                        <button
                            type="button"
                            className={
                                props.type === "disapprove"
                                    ? "button-warning-fill"
                                    : "button-primary"
                            }
                            onClick={handleAddNote}
                        >
                            Confirm
                        </button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
}
